import type { NextPage } from 'next'

import { PageBackgroundColor } from 'src/components/layouts/Page'
import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const OurBusinessFunders: NextPage = () => {
  return (
    <SanityContentPage
      backgroundColor={PageBackgroundColor.linen}
      slug='our-business-funders'
    />
  )
}

export default OurBusinessFunders
